export const DATUM_OPTIONS = [
  { Code: 'Coor', Description: 'Coordinates' },
  { Code: 'Deg', Description: 'Degrees' },
];

export const DEFAULT_VALUES = {
  Latitude: '',
  Longitude: '',
  UncertaintyDistance: '',
  Datum: '',
  CoordinateDT: null,
  Altitude: '',
  AltitudeRefPoint: '',
  CellID: '',
  SectorID: '',
  Speed: '',
  AltitudeUnitMeasure: '',
  SpeedUnitMeasure: '',
};

export const DEFAULT_CENTER = { lat: 30.39, lng: -91.07 };

export const DEFAULT_MENU_POS = { x: 100, y: 100 };

export const CURRENT_MAP_OPTIONS = {
  mapTypeControlOptions: { style: 1, position: 11 },
  zoomControlOptions: { position: 11 },
};
